<template></template>
<script>
import { mapActions } from "vuex"

export default {
  methods: {
    ...mapActions(["logout"]),
  },
  async created() {
    try {
      await this.logout()
    } finally {
      this.$router.push("/admin/auth/login")
    }
  },
}
</script>
